import { isString } from './common';

export function upperFirst(text: string) {
  if (!isString(text)) return text;
  return text.charAt(0).toUpperCase() + text.slice(1);
}
